var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "134", height: "205", viewBox: "0 0 134 205", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "window 1"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#FFF", d: "M1.671 1h132V204h-132V15.926z" }),
      React.createElement("path", { d: "M133.338 15.926V1H1.004v14.926m132.334 0v180.777m0-180.777h-8.334m-124 0v180.777m0-180.777h9.334M1.004 196.703h9.334m-9.334 0V204h132.334v-7.297m-123 0V15.926m0 180.777h114.666M10.338 15.926h114.666m8.334 180.777h-8.334m0 0V15.926", stroke: "#000" }),
      React.createElement("path", { fill: "#C4C4C4", d: "M11.671 16h113v180h-113z" }),
      React.createElement("path", { fill: "#D8F1FF", d: "M17.671 23h47v38h-47zM70.671 23h47v38h-47zM17.671 64h47v38h-47zM70.671 64h47v38h-47zM17.671 109h47v38h-47zM70.671 109h47v38h-47zM17.671 151h47v38h-47zM70.671 151h47v38h-47z" }),
      React.createElement("path", { strokeOpacity: ".2", stroke: "#000", d: "M49.671 33l-10 10M59.671 33l-10 10M59.671 43l-14 14M49.671 74l-10 10M59.671 74l-10 10M59.671 83l-14 14M49.671 117l-10 10M59.671 117l-10 10M59.671 127l-14 14M49.671 158l-10 10M59.671 158l-10 10M59.671 168l-14 14M103.671 72l-10 10M113.671 72l-10 10M113.671 81l-14 14M103.671 31l-10 10M113.671 31l-10 10M113.671 41l-14 14M103.671 117l-10 10M113.671 117l-10 10M113.671 127l-14 14M103.671 158l-10 10M113.671 158l-10 10M113.671 168l-14 14" })
    )
  );
});